import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import get from 'lodash/get';
import biLogger from '@wix/web-bi-logger';
import ddt from '@wix/da-ddt';
import { getReferrer, commitReferrer } from './referrer';
export class BiLogger {
    getLogger(contextData) {
        if (typeof window !== 'undefined') {
            this.defaultOptions.url = window.location.toString();
            if (document.referrer) {
                this.defaultOptions.referer = document.referrer;
            }
        }
        if (contextData) {
            this.defaultOptions.platform = contextData.isMobile ? 'mobile' : 'desktop';
            // Try to detect pwa (progressive web app) platform
            if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && (window.matchMedia('(display-mode: standalone)').matches || get(window, 'navigator.standalone') === true)) {
                this.defaultOptions.platform = 'pwa';
            }
            if (contextData.biClientId) {
                this.defaultOptions.client_id = contextData.biClientId;
            }
            if (contextData.useridUuid) {
                this.defaultOptions.uuid = contextData.useridUuid;
            }
            this.defaultOptions.requestid = contextData.requestId;
            this.defaultOptions.view = contextData.view;
            this.defaultOptions.component = contextData.component;
        }
        return biLogger.factory({
            endpoint: 'da-client',
            trackSession: false
        }).updateDefaults(this.defaultOptions).logger();
    }
    log(contextData, _param) {
        var { _biLoggerVersion, _value, _rankIndex } = _param, eventData = _object_without_properties(_param, [
            "_biLoggerVersion",
            "_value",
            "_rankIndex"
        ]);
        // we are not supposed to send client events from server
        if (typeof window === 'undefined') {
            ddt.error('bilogger', 'Attempted to send client event in SSR, fix me now', eventData);
            return Promise.resolve();
        }
        // if a new pageview, time to save referrer
        if (eventData.evid === 99) {
            commitReferrer();
        }
        const myLogger = this.getLogger(contextData);
        const biData = _object_spread(_object_spread_props(_object_spread({}, this.defaultOptions), {
            referer: getReferrer()
        }), eventData);
        const logData = biData;
        // you may need to instruct your browser to preserve logs to be able to
        // see these messages
        ddt.log('bilogger', `(evid: ${logData.evid})`, logData, JSON.stringify(logData));
        // we are not supposed to send events from dev
        if (process.env.NODE_ENV !== 'production') {
            return Promise.resolve();
        }
        return myLogger.log(logData);
    }
    constructor(){
        _define_property(this, "defaultOptions", {
            version: 'eclipse;major',
            platform: 'desktop',
            src: 82
        });
    }
}
const logger = new BiLogger();
export default logger;

//# sourceMappingURL=BiLogger.logger.js.map